import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import COLORS from '../../resources/style/Themes';

type DefaultIconButtonProps = {
  action: () => void;
  icon: React.ReactNode;
  label: string;
  disabled: boolean;
} & ButtonProps;

const DefaultIconButton = ({
  action,
  icon,
  label,
  disabled,
}: DefaultIconButtonProps) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      startIcon={icon}
      onClick={action}
      disabled={disabled}
      sx={{
        borderRadius: '10px',
        height: '42px',
        paddingBottom: 0.5,
        textAlign: 'center',
        justifyContent: 'center',
        backgroundColor: disabled ? COLORS.GREY : undefined,
        float: 'right',
        '&:hover': {
          backgroundColor: disabled ? COLORS.GREY : undefined,
        },
      }}
    >
      {label}
    </Button>
  );
};

export default DefaultIconButton;
